import {faPlus} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Formik} from 'formik'
import React, {FC, Fragment, useEffect, useMemo, useState} from 'react'
import {Alert, Button, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import CopyToClipboard from 'react-copy-to-clipboard'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {PlatformSettingDataTypesValues} from 'src/app/_interfaces/setting.interface'
import useAppToast from 'src/hooks/useAppToast'
import {
  getRefreshMappingErrorMessage,
  getRefreshMappingSuccessMessage,
  isApiPayloadSuccess,
} from 'src/utils/refreshMappingResponse'
import Loader from 'src/utils/Loader'
import {
  PLATFORM_FIELD,
  RetrievePlatformDataType,
  ShippingMethodMapping,
  platformfielddata_set,
} from 'src/interfaces/Platform.interface'
import {
  createPlatformSettingAsync,
  getPlatformTokenDatasync,
  retrivePlatformDataAsync,
  setPlatformTokenDatasync,
} from 'src/redux/actions/platformActions'
import {
  deleteFieldMappingAsync,
  getFieldMappingAsync,
  getPlatformFieldsAsync,
  getPlatformFieldsForMainStoreAsync,
  getPlatformFieldsForMainStoreForLocationAsync,
  saveFieldMappingAsync,
} from 'src/redux/actions/productActions'
import {getPlatformParentFieldDataCategoriesAsync} from 'src/redux/actions/templateAndPricingActions'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {toast} from 'react-toastify'
import {isActiveBoolean} from 'src/redux/actions/changeisActiveAction'
import ShipmentSyncValues from 'src/app/pages/listing/components/ShipmentSyncValues'
import WarehouseMapping from 'src/app/pages/listing/components/WareHouseMapping'
import { setInitialPopupDataAsync } from 'src/redux/actions/authActions'
import { refreshMappingAsync } from 'src/redux/actions/platformSettingActions'
import { loggedInAdminAccessToken } from 'src/utils/constants'
import { getCurrentUTCDateTime } from 'src/utils/modals/CurrentDateTimeUTC'
import { BaseNames } from 'src/marketConnect/helpers'

const InfoTooltip = ({message = ''}) => {
  return (
    <OverlayTrigger placement='right' overlay={<Tooltip>{message}</Tooltip>}>
      <i className='bi bi-info-circle text-dark fs-5 ms-3'></i>
    </OverlayTrigger>
  )
}

type IdentifierOption = {
  api_id?: string
  name?: string
  display_name?: string | null
}

const getIdentifierValue = (option: IdentifierOption) =>
  option?.api_id ?? option?.name ?? ''

const getIdentifierLabel = (option: IdentifierOption) =>
  option?.display_name ?? option?.name ?? option?.api_id ?? ''

const DEFAULT_IDENTIFIER_OPTIONS: IdentifierOption[] = [
  {api_id: 'SKU', display_name: 'SKU'},
  {api_id: 'UPC', display_name: 'UPC'},
]

const THERANGEPLUS_SECONDARY_OPTIONS: IdentifierOption[] = [
  {api_id: 'SKU', display_name: 'Product Reference'},
  {api_id: 'UPC', display_name: 'UPC'},
]

type PlatformConfigurationPropsType = {
    selectedPlatformId:string|undefined
    afterSettingCB:()=>void
}

const PlatformConfiguration:FC<PlatformConfigurationPropsType> = ({selectedPlatformId,afterSettingCB}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const toArray = (value: unknown): any[] => (Array.isArray(value) ? value : [])

  const {errorToast, successToast, warningToast} = useAppToast()
  const [isShortCodeVisible, setIsShortCodeVisible] = useState(false)
  const [isNotesShortCodeVisible, setIsNotesShortCodeVisible] = useState(false)
  const [copyMarkup, setCopyMarkup] = useState<boolean>(false)
  const [copyMarkup2, setCopyMarkup2] = useState<boolean>(false)
  const [buttonString, setButtonString] = useState('')
  const [buttonString2, setButtonString2] = useState('')
  const [shortCode, setShortCode] = useState(['[ORDER_NUMBER]'])
  const [platformDisplayName, setPlatformDisplayName] = useState<string>('')
  const [temuTokenData, setTemuTokenData] = useState({token:'', expire_date:''})
  const [loading, setLoading] = useState(false)
  const [mainStoreLocationsFieldData, setMainStoreLocationsFieldData] = useState<
    platformfielddata_set[] | []
  >([])
  const { fetchedUserAccountData } = useAppSelector(state=>state.userAccountData)
  const [shippingMethodMappings, setShippingMethodMappings] = useState<ShippingMethodMapping[]>([
    {
      id: null,
      source_platform_data_id: '',
      destination_platform_data_id: '',
      destination_platform_data_str: '',
      source_platform_data_str: '',
    },
  ])

  const [retrivedPlatformData, setRetrivedPlatformData] = useState<RetrievePlatformDataType | null>(
    null
  )
  const {retrivedPlatformLoading} = useAppSelector((state) => state.retrivePlatformData)

  const {mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  const [fieldValuesLoader, setFieldValuesLoader] = useState(false)
  const {shipmentFieldMappings} = useAppSelector((state) => state.productsOfSingleChannel)

  const [platformFields, setPlatformFields] = useState<{
    mainStorePlatformField: null | PLATFORM_FIELD
    selectedPlatformOfPlatformField: null | PLATFORM_FIELD
  }>({
    mainStorePlatformField: null,
    selectedPlatformOfPlatformField: null,
  })
  const [shipmentMappingFieldData, setShipmentMappingFieldData] = useState<{
    shipmentMappingFieldDataForSelectedStore: platformfielddata_set[] | []
    shipmentMappingFieldDataForMainStore: platformfielddata_set[] | []
  }>({shipmentMappingFieldDataForMainStore: [], shipmentMappingFieldDataForSelectedStore: []})

  const {connectedPlatformData} = useAppSelector((state) => state.connectedPlatform)

  //Warehouse mapping
  const [warehouseMappingLoading, setWarehouseMappingLoading] = useState(false)
  const [warehouseMappings, setWarehouseMappings] = useState<ShippingMethodMapping[]>([
    {
      id: null,
      source_platform_data_id: '',
      destination_platform_data_id: '',
      destination_platform_data_str: '',
      source_platform_data_str: '',
    },
  ])
  const [warehousePlatformFields, setWarehousePlatformFields] = useState<{
    mainStorePlatformField: null | PLATFORM_FIELD
    selectedPlatformOfPlatformField: null | PLATFORM_FIELD
  }>({
    mainStorePlatformField: null,
    selectedPlatformOfPlatformField: null,
  })
  const [warehouseMappingData, setWarehouseMappingData] = useState<{
    shipmentMappingFieldDataForSelectedStore: platformfielddata_set[] | []
    shipmentMappingFieldDataForMainStore: platformfielddata_set[] | []
  }>({shipmentMappingFieldDataForMainStore: [], shipmentMappingFieldDataForSelectedStore: []})

    const [refreshMapping	, setRefreshMapping	] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
     const [disableRefreshButton, setDisableRefreshButton] = useState(false);                      
     const [hasCooldownStarted, setHasCooldownStarted] = useState(false);
     const [timeLeft, setTimeLeft] = useState(0);
     const [showAlert, setShowAlert] = useState(false);

  const availableSettings = useMemo(() => {
    const rootSettings = toArray(retrivedPlatformData?.available_platform_settings)
    const infoSettings = toArray(retrivedPlatformData?.platform_info?.available_platform_settings)
    return [...rootSettings, ...infoSettings]
  }, [retrivedPlatformData])

  const requiresErpIdentifier = useMemo(() => {
    if (retrivedPlatformData?.isErpStore) {
      return true
    }
    return availableSettings.some(
      (setting: any) =>
        setting?.group_code === 'IDENTIFIER' && setting?.name === 'erp_product_identifier'
    )
  }, [retrivedPlatformData, availableSettings])

  const erpIdentifierOptions = useMemo(() => {
    if (!requiresErpIdentifier) {
      return []
    }
    const erpSetting = availableSettings.find(
      (setting: any) =>
        setting?.group_code === 'IDENTIFIER' && setting?.name === 'erp_product_identifier'
    )
    return Array.isArray(erpSetting?.setting_options) ? erpSetting?.setting_options : []
  }, [availableSettings, requiresErpIdentifier])

  const secondaryIdentifierOptions = useMemo(() => {
    const secondarySetting = availableSettings.find(
      (setting: any) =>
        setting?.group_code === 'IDENTIFIER' && setting?.name === 'secondary_product_identifier'
    )
    return Array.isArray(secondarySetting?.setting_options) ? secondarySetting?.setting_options : []
  }, [availableSettings])

  const mainStoreAvailableSettings = useMemo(() => {
    const rootSettings = toArray((mainStoreData as any)?.available_platform_settings)
    const infoSettings = toArray(mainStoreData?.platform_info?.available_platform_settings)
    return [...rootSettings, ...infoSettings]
  }, [mainStoreData])

  const primaryIdentifierOptions = useMemo(() => {
    const primarySetting = mainStoreAvailableSettings.find(
      (setting: any) =>
        setting?.group_code === 'IDENTIFIER' && setting?.name === 'main_product_identifier'
    )
    return Array.isArray(primarySetting?.setting_options) ? primarySetting?.setting_options : []
  }, [mainStoreAvailableSettings])

  const handleCopyMarkup = (data: string) => {
    setCopyMarkup(true)
    setButtonString(data)

    setTimeout(() => {
      setCopyMarkup(false)
      setButtonString('')
    }, 1000)
  }

  const handleCopyMarkup2 = (data: string) => {
    setCopyMarkup2(true)
    setButtonString2(data)

    setTimeout(() => {
      setCopyMarkup(false)
      setButtonString2('')
    }, 1000)
  }

  function formatDateString(dateString: string) {
    // Parse the date string to a Date object
    let date
    if (dateString) {
      if (dateString.endsWith('Z')) {
        let zremovedval = dateString.slice(0, dateString.length - 4)
        // If the date string ends with 'Z', it's in UTC
        date = new Date(zremovedval)
      } else {
        // Otherwise, it's in the local time zone
        date = new Date(dateString)
      }
      // Adjust the date to the local time zone if needed
      const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)

      // Format the local date for the datetime-local input
      return localDate.toISOString().slice(0, 16)
    } else {
      return null
    }
  }

  const initialValues: PlatformSettingDataTypesValues = {
    main_product_identifier: '',
    erp_product_identifier: '',
    secondary_product_identifier: '',
    identifier_setting: {
      main_product_identifier: '',
      secondary_product_identifier: '',
      erp_product_identifier: '',
    },
    pricing_setting: {
      isPriceSync: false,
      // repricing: {
      //   type: 'FLAT',
      //   value: '',
      // },
    },
    inventory_setting: {
      isInventorySync: false,
      default_location: '',
      buffer: 0,
    },
    order_setting: {
      order_number_map: '',
      order_note_map: '',
      isNotifyUnlinkedOrders: false,
      isSkipUnpaidOrders: false,
      isImportOrderToSource: false,
      sync_start_date: null,
      isImportCanceledOrder: false,
      isAcceptOrder: false,
      estimated_delivery_days: null,
      estimated_dispatch_days: null,
      tags: '',
    },
    product_setting: {
      isImportProductFromSource: false,
      default_quantity: 0,
      export_product: false,
    },
    shipment_setting: {
      isImportShipmentFromMain: false,
    },
  }

  const formInitialValues = useMemo<PlatformSettingDataTypesValues>(() => {
    const platformSettings =
      (retrivedPlatformData?.platform_settings as Partial<PlatformSettingDataTypesValues> | undefined) ??
      {}
    const identifierSetting = {
      ...initialValues.identifier_setting,
      ...(platformSettings.identifier_setting ?? {}),
    }
    const mainIdentifierValue =
      platformSettings?.main_product_identifier ??
      identifierSetting.main_product_identifier ??
      initialValues.main_product_identifier
    const secondaryIdentifierValue =
      platformSettings?.secondary_product_identifier ??
      identifierSetting.secondary_product_identifier ??
      initialValues.secondary_product_identifier
    const erpIdentifierValue =
      platformSettings?.erp_product_identifier ??
      identifierSetting.erp_product_identifier ??
      initialValues.erp_product_identifier
    return {
      ...initialValues,
      ...platformSettings,
      main_product_identifier: mainIdentifierValue ?? '',
      secondary_product_identifier: secondaryIdentifierValue ?? '',
      erp_product_identifier: erpIdentifierValue ?? '',
      identifier_setting: identifierSetting,
    }
  }, [retrivedPlatformData])

  const renderTooltip = (shortcode: string) => {
    let tooltipText = ''
    switch (shortcode) {
      case '[ORDER_ID]':
        tooltipText = ` ${mainStoreData?.code} Auto Generated`
        break
      case '[ORDER_NUMBER]':
        tooltipText = `Order Number from ${retrivedPlatformData?.code}`
        break
      default:
        tooltipText = ''
    }
    return <Tooltip id={`${shortcode}-tooltip`}>{tooltipText}</Tooltip>
  }

  useEffect(() => {
    if (selectedPlatformId && mainStoreData?.id) {
      setFieldValuesLoader(true)
      Promise.all([
        dispatch(
          getPlatformFieldsAsync({
            platformId: Number(selectedPlatformId),
            otherParams: {field_code: 'SHIPPINGPROVIDER'},
          })
        ).then((response) => {
          if (response.payload?.length) {
            setPlatformFields((pre) => {
              return {...pre, selectedPlatformOfPlatformField: response.payload[0]}
            })
            dispatch(
              getPlatformParentFieldDataCategoriesAsync({platform_Id: response.payload[0].id})
            ).then((response) => {
              setShipmentMappingFieldData((pre) => {
                return {...pre, shipmentMappingFieldDataForSelectedStore: response.payload}
              })
            })
          }
        }),
        dispatch(
          getPlatformFieldsForMainStoreAsync({
            platformId: mainStoreData?.id,
            otherParams: {field_code: 'SHIPPINGPROVIDER'},
          })
        ).then((response) => {
          if (response.payload?.length) {
            setPlatformFields((pre) => {
              return {...pre, mainStorePlatformField: response.payload[0]}
            })
            dispatch(
              getPlatformParentFieldDataCategoriesAsync({platform_Id: response.payload[0].id})
            ).then((response) => {
              setShipmentMappingFieldData((pre) => {
                return {...pre, shipmentMappingFieldDataForMainStore: response.payload}
              })
            })
          }
        }),
        dispatch(
          getPlatformFieldsForMainStoreForLocationAsync({
            platformId: mainStoreData?.id,
            otherParams: {field_code: 'LOCATION'},
          })
        ).then((response) => {
          if (response.payload?.length) {
            dispatch(
              getPlatformParentFieldDataCategoriesAsync({platform_Id: response.payload[0].id})
            ).then((response) => {
              setMainStoreLocationsFieldData(response.payload)
            })
          }
        }),
      ])
        .then(() => {
          setFieldValuesLoader(false)
        })
        .catch(() => {
          setFieldValuesLoader(false)
        })
    }
  }, [selectedPlatformId, mainStoreData, refreshMapping])

  useEffect(() => {
    if (shipmentFieldMappings.length) {
      const shippingProviderMappings = shipmentFieldMappings.find(
        (item) => item.destination_field.api_code === 'SHIPPINGPROVIDER'
      )
      const warehouseMappings = shipmentFieldMappings.find(
        (item) => item.destination_field.api_code === 'LOCATION'
      )

      if (shippingProviderMappings) {
        const savedFieldMappings = shippingProviderMappings?.fieldmappingdata_set?.map((item) => {
          return {
            id: item?.id,
            destination_platform_data_id: item?.destination_platform_data?.id ? item?.destination_platform_data?.id + '' : '' ,
            source_platform_data_id: item?.source_platform_data?.id ? item?.source_platform_data?.id + '' : '' ,
            destination_platform_data_str: item.destination_platform_data_str ?? '' ,
            source_platform_data_str: item.source_platform_data_str ?? ''
          }
        })
        setShippingMethodMappings(savedFieldMappings)
      }

      if (warehouseMappings) {
        const savedFieldMappings = warehouseMappings?.fieldmappingdata_set?.map((item) => {
          return {
            id: item?.id,
            destination_platform_data_id: item?.destination_platform_data?.id ? item?.destination_platform_data?.id + '' : '' ,
            source_platform_data_id: item?.source_platform_data?.id ? item?.source_platform_data?.id + '' : '' ,
            destination_platform_data_str: item.destination_platform_data_str ?? '' ,
            source_platform_data_str: item.source_platform_data_str ?? ''
          }
        })
        setWarehouseMappings(savedFieldMappings)
      }
    }
  }, [shipmentFieldMappings, refreshMapping])

  useEffect(() => {
    if (selectedPlatformId && mainStoreData?.id) {
      setWarehouseMappingLoading(true)
      Promise.all([
        dispatch(
          getPlatformFieldsAsync({
            platformId: Number(selectedPlatformId),
            otherParams: {field_code: 'LOCATION'},
          })
        ).then((response) => {
          if (response.payload?.length) {
            setWarehousePlatformFields((pre) => {
              return {...pre, selectedPlatformOfPlatformField: response.payload[0]}
            })
            dispatch(
              getPlatformParentFieldDataCategoriesAsync({platform_Id: response.payload[0].id})
            ).then((response) => {
              setWarehouseMappingData((pre) => {
                return {...pre, shipmentMappingFieldDataForSelectedStore: response.payload}
              })
            })
          }
        }),
        dispatch(
          getPlatformFieldsForMainStoreAsync({
            platformId: mainStoreData?.id,
            otherParams: {field_code: 'LOCATION'},
          })
        ).then((response) => {
          if (response.payload?.length) {
            setWarehousePlatformFields((pre) => {
              return {...pre, mainStorePlatformField: response.payload[0]}
            })
            dispatch(
              getPlatformParentFieldDataCategoriesAsync({platform_Id: response.payload[0].id})
            ).then((response) => {
              setWarehouseMappingData((pre) => {
                return {...pre, shipmentMappingFieldDataForMainStore: response.payload}
              })
            })
          }
        }),
      ])
        .then(() => {
          setWarehouseMappingLoading(false)
        })
        .catch(() => {
          setWarehouseMappingLoading(false)
        })
    }
  }, [selectedPlatformId, mainStoreData, refreshMapping])

  const handleSaveWarehouseMappings = () => {
    let mapping_for_save = warehouseMappings.map((item) => {
      if (item.id) {
        return item
      } else {
        return {
          id: null,
          source_platform_data_id: item?.source_platform_data_id,
          destination_platform_data_id: item?.destination_platform_data_id,
          source_platform_data_str: item?.source_platform_data_str,
          destination_platform_data_str: item?.destination_platform_data_str,
        }
      }
    })

    if (!warehousePlatformFields.selectedPlatformOfPlatformField?.id) {
      return warningToast('Destination field is required')
    }

    if (!warehousePlatformFields.mainStorePlatformField?.id) {
      return warningToast('Source field is required')
    }

    setWarehouseMappingLoading(true)

    dispatch(
      saveFieldMappingAsync({
        source_field_id: warehousePlatformFields.mainStorePlatformField?.id!,
        destination_field_id: warehousePlatformFields.selectedPlatformOfPlatformField?.id!,
        fieldmappingdata_set: mapping_for_save,
      })
    ).then(() => {
      dispatch(getFieldMappingAsync({destination_platform_id: selectedPlatformId}))
      setWarehouseMappingLoading(false)
    })
  }

  useEffect(() => {
    if (selectedPlatformId) {
      Promise.all([
        dispatch(retrivePlatformDataAsync({id: selectedPlatformId})).then((resp) => {
          if (resp?.payload) {
            let shadowSetting = {...resp.payload}
            let shadowInitials = {...initialValues}
            if (resp.payload?.platform_settings) {
              let shadowPltfrmSetting = {...resp.payload?.platform_settings}
              for (let setting in shadowPltfrmSetting) {
                if (setting.includes('setting')) {
                  if (shadowPltfrmSetting[setting] == null) {
                    // shadowSetting['platform_settings'][setting] = {}
                    shadowPltfrmSetting[setting] = shadowInitials[setting]
                    // Object.assign(shadowSetting['platform_settings'][setting],shadowInitials[setting])
                    console.log(
                      shadowPltfrmSetting[setting],
                      'setting in field',
                      setting,
                      shadowInitials[setting]
                    )
                  }
              }
            }
            if (shadowPltfrmSetting?.erp_product_identifier === undefined || shadowPltfrmSetting?.erp_product_identifier === null) {
              shadowPltfrmSetting['erp_product_identifier'] = shadowInitials.erp_product_identifier
            }
            shadowSetting['platform_settings'] = {...shadowPltfrmSetting}
          } else {
            shadowSetting['platform_settings'] = {...shadowInitials}
          }

            setRetrivedPlatformData(shadowSetting)
          }
        }),
        dispatch(getFieldMappingAsync({destination_platform_id: selectedPlatformId})),
      ])
    }
  }, [selectedPlatformId, refreshMapping])

  const handleSaveShipmentMappings = () => {
    let mapping_for_save = shippingMethodMappings.map((item) => {
      if (item.id) {
        return item
      } else {
        return {
          id: null,
          source_platform_data_id: item?.source_platform_data_id,
          destination_platform_data_id: item?.destination_platform_data_id,
          source_platform_data_str: item?.source_platform_data_str,
          destination_platform_data_str: item?.destination_platform_data_str,
        }
      }
    })

    if (!platformFields.selectedPlatformOfPlatformField?.id) {
      return warningToast('Destination field is required')
    }

    if (!platformFields.mainStorePlatformField?.id) {
      return warningToast('Source field is required')
    }

    setFieldValuesLoader(true)

    dispatch(
      saveFieldMappingAsync({
        source_field_id: platformFields.mainStorePlatformField?.id!,
        destination_field_id: platformFields.selectedPlatformOfPlatformField?.id!,
        fieldmappingdata_set: mapping_for_save,
      })
    )
      .then(() => {
        dispatch(getFieldMappingAsync({destination_platform_id: selectedPlatformId}))
        setFieldValuesLoader(false)
      })
      .catch(() => {
        setFieldValuesLoader(false)
      })
  }

  //to get data of temu token and expiration date
  useEffect(() => {
    if(selectedPlatformId && retrivedPlatformData && retrivedPlatformData?.code==='TEMU' ){
      dispatch(getPlatformTokenDatasync({id:selectedPlatformId}))
      .then((res)=>{
        if(res.payload?.status_code=='200'){
          setTemuTokenData({
            token:'',
            expire_date:res.payload?.data?.expiry_date
          })
        }
      })
    }
  }, [selectedPlatformId, retrivedPlatformData, refreshMapping])
 
   useEffect(() => {
      if (!hasCooldownStarted) return;
  
      if (timeLeft <= 0) {
        setDisableRefreshButton(false)
        setHasCooldownStarted(false);
        setShowAlert(false);
        return;
      }
  
      const timer = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);
  
      return () => clearInterval(timer);
    }, [hasCooldownStarted, timeLeft]);
  
    const handleRefreshMapping = async () => {
      if (hasCooldownStarted) {
        setDisableRefreshButton(true)
        setShowAlert(true);
        return;
      }
  
      // First click (or after cooldown expired)
      setIsDisabled(true);
      setShowAlert(false);
  
      const payload = { platform_id: Number(selectedPlatformId) };

      try {
        const response = await dispatch(refreshMappingAsync({ payload })).unwrap()
        if (!isApiPayloadSuccess(response)) {
          throw response
        }
        setRefreshMapping((prev) => !prev);
        if (localStorage.getItem(loggedInAdminAccessToken)) {
          successToast(getRefreshMappingSuccessMessage(response));
        }
        localStorage.removeItem(`platformFirstConnect_${retrivedPlatformData?.name}_${retrivedPlatformData?.id.toString()}`);
      } catch (error) {
        errorToast(getRefreshMappingErrorMessage(error));
      } finally {
        setIsDisabled(false);
        setHasCooldownStarted(true);
        setTimeLeft(60);
      }
    };

    useEffect(()=>{
      if(selectedPlatformId && retrivedPlatformData){
         const firstConnect = localStorage.getItem(`platformFirstConnect_${retrivedPlatformData?.name}_${retrivedPlatformData?.id.toString()}`)
      if (firstConnect === 'true') {
        handleRefreshMapping()
      }
    }
    },[selectedPlatformId, retrivedPlatformData ])

  return (
    <>
      <div className='p-2 px-5 rounded bg-light-info my-2 fs-5 mb-4' >
        <i className="bi bi-telephone-fill fw-bold text-primary fs-5"></i> Book a call <a className='fw-bold' target='_blank'  href="https://calendly.com/d/crrg-dfq-xkv/product-demo-integration-flow-discussion" rel="noreferrer">here</a>,  We'll set it up for free!  
      </div>
      {localStorage.getItem(loggedInAdminAccessToken) && showAlert && timeLeft > 0 && (
              <div className='d-flex justify-content-end'>
                    <Alert variant="danger" className="px-2 py-1 mb-2">
                      ⏳ Please wait <strong className="mx-1">{timeLeft}s</strong> before trying again.
                    </Alert>
                    </div>
                  )}
      <div className='card' key={retrivedPlatformData + ''}>
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
          onSubmit={(values, helpers) => {
            console.log('values', values)
            helpers.setSubmitting(true)
            const payloadValues: any = {...values}
                      // Update sync start date time as current utc , if order setting is enabled
                      const isOrderSettingEnabled = payloadValues?.order_setting?.isImportOrderToSource ?? false            
                      if (isOrderSettingEnabled) {
                        payloadValues.order_setting['sync_start_date'] = getCurrentUTCDateTime()
                      }
                      const identifierSettingPayload = {
                        ...(payloadValues.identifier_setting || {}),
                        secondary_product_identifier: payloadValues.secondary_product_identifier || '',
                      }
                      if (requiresErpIdentifier) {
                        identifierSettingPayload['erp_product_identifier'] =
                          payloadValues.erp_product_identifier || ''
                        identifierSettingPayload['main_product_identifier'] = ''
                      } else {
                        identifierSettingPayload['main_product_identifier'] =
                          payloadValues.main_product_identifier || ''
                        identifierSettingPayload['erp_product_identifier'] = ''
                      }
                      payloadValues.identifier_setting = identifierSettingPayload
                      if (requiresErpIdentifier) {
                        delete payloadValues.main_product_identifier
                      } else {
                        delete payloadValues.erp_product_identifier
                      }
            const allSettings = {
              platformId: Number(selectedPlatformId),
              ...payloadValues,
            }
            try {
              setLoading(true)
              dispatch(createPlatformSettingAsync(allSettings)).then(async (response) => {
                console.log('response in connected platform', response)
                if (response?.payload?.status_code === 200) {
                  // alert("connectedplatform toast")
                  await dispatch(setInitialPopupDataAsync({isOnboardingProcessCompleted:true}))
                  helpers.setSubmitting(false)
                  toast.success('Channel settings saved successfully !', {
                    autoClose: 3000, // Set the duration for which the toast will be displayed
                  })
                  afterSettingCB()
                  if(fetchedUserAccountData?.is_subscribed){
                    navigate('/dashboard')
                  }else{
                    navigate('/pricing')
                  }
                  if (selectedPlatformId) {
                    dispatch(retrivePlatformDataAsync({id: selectedPlatformId}))
                  }
                  setLoading(false)
                }
              })
              if(retrivedPlatformData?.code==='TEMU'){
                dispatch(setPlatformTokenDatasync({id:{id:selectedPlatformId}, payload:{ expiry_date:temuTokenData.expire_date, token:temuTokenData.token} }))
                .then(() => undefined)
                .catch(() => undefined)
              }
              console.log('Channel settings created successfully!', allSettings)
              setLoading(false)
              // showSuccessToast() // Show toast on successful save
            } catch (error) {
              console.error('Error creating platform settings:', error)
              helpers.setSubmitting(false)
              setLoading(false)
            }

            const id = Number(selectedPlatformId)!
            const display_name = connectedPlatformData?.display_name
            const isActive = connectedPlatformData?.isActive == false ? true : true
            const payload = {
              display_name,
              isActive,
            }

            dispatch(isActiveBoolean({...payload, id}))
          }}
        >
          {({handleSubmit, handleChange, setFormikState, values, isSubmitting, setSubmitting}) => {
            const isIdentifierMissing = requiresErpIdentifier
              ? (values.erp_product_identifier || '').length === 0 ||
                (values.secondary_product_identifier || '').length === 0
              : (values.main_product_identifier || '').length === 0 ||
                (values.secondary_product_identifier || '').length === 0
            const isTheRangePlus = retrivedPlatformData?.code === 'THERANGEPLUS'
            const erpOptionsToRender: IdentifierOption[] =
              erpIdentifierOptions.length > 0 ? erpIdentifierOptions : DEFAULT_IDENTIFIER_OPTIONS
            const secondaryFallback = isTheRangePlus
              ? THERANGEPLUS_SECONDARY_OPTIONS
              : DEFAULT_IDENTIFIER_OPTIONS
            const secondaryOptionsToRender: IdentifierOption[] =
              secondaryIdentifierOptions.length > 0 ? secondaryIdentifierOptions : secondaryFallback
            const primaryFallback: IdentifierOption[] = [
              ...DEFAULT_IDENTIFIER_OPTIONS,
              ...(mainStoreData?.code === 'SHOPIFY'
                ? [{api_id: 'API_ID', display_name: 'Shopify Variant Id'}]
                : []),
            ]
            const primaryOptionsToRender: IdentifierOption[] =
              primaryIdentifierOptions.length > 0 ? primaryIdentifierOptions : primaryFallback
            return (
              <form onSubmit={handleSubmit} 
                className={isDisabled ? 'background-disable': ''}
               >
                <div className='card-header bg-white'>
                  <div className='card-title'>
                    <span>Channel Settings</span>
                    {/* <div className='d-flex flex-column'>
                      <p className='mb-0'>The Range Store Friendly Name: The Range </p>
                      <small>
                        <span className='badge badge-success'>Connected</span>
                      </small>
                    </div> */}
                  </div>
                  <div className='card-toolbar'>
                    {/* <Link to={'/listing-channels'} className='btn btn-sm btn-primary  me-2'>
                      Close
                    </Link> */}
             {localStorage.getItem(loggedInAdminAccessToken) && (<button
               type="button"
               disabled={disableRefreshButton}
               onClick={handleRefreshMapping}
               className="btn btn-sm me-2 fw-bold"
               style={{backgroundColor: '#07bc0c', color: 'white'}}
             >
               {isDisabled ? 'Refreshing...' : 'Refresh Mapping'}
               </button>)}
                    <button
                      className='btn btn-sm text-white fw-bold '
                      type='submit'
                      style={{backgroundColor:'#07bc0c'}}
                      disabled={
                        isIdentifierMissing ||
                        loading ||
                        isSubmitting
                      }
                    >
                      {isSubmitting ? 'Saving..' : 'Save Changes'}
                    </button>
                  </div>
                </div>

                {retrivedPlatformLoading ? (
                  <div className='d-flex align-items-center justify-content-center h-100'>
                    <Loader variant="section" />
                  </div>
                ) : (
                  <div className='card-body px-sm-4.5'>
                    <div className='mt-3 border shadow rounded'>
                      <div className='  ribbon ribbon-start'>
                        <div className='ribbon-label bg-primary z-0'>Platform Connection</div>
                      </div>
                      <div className='row m-4'>
                        <div className='col-12 col-sm-4 h4'>
                          {' '}
                          {retrivedPlatformData?.platform_info?.display_name} Store Channel Name:
                        </div>
                        <div className='col-6 col-sm-6 d-flex align-items-center h4'>
                          {' '}
                          {retrivedPlatformData?.display_name}
                        </div>

                        <div className='w-100'></div>

                        <div className='row'>
                          <div className='col-6 col-sm-4 h4 mt-1 '>Status:</div>
                          <div className='col-6 col-sm-6 mt-1 ms-sm-2'>
                            <span
                              className={`badge ${
                                retrivedPlatformData?.isConnected ? '' : 'badge-danger'
                              }`}
                              style={{fontSize: '1.3rem', borderRadius: '6px',  backgroundColor : retrivedPlatformData?.isConnected ? '#07bc0c' : ''  }}
                            >
                              {retrivedPlatformData?.isConnected ? 'Connected' : 'Not Connected'}
                            </span>
                          </div>
                        </div>

                        <div className='w-100'></div>

                        {retrivedPlatformData?.code === 'SHOPIFY' && (
                          <>
                            <div className='col-12 col-sm-4 h4 mt-1'>
                              {retrivedPlatformData?.platform_info?.display_name} {''}Url:
                            </div>
                            <div className='col-12 col-sm-6 h4 mt-1'>
                              {retrivedPlatformData?.credentials?.identifier}
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {
                      retrivedPlatformData?.code === 'TEMU' ? 
                      <div className='mt-5 border shadow rounded'>
                        <div className='  ribbon ribbon-start'>
                          <div className='ribbon-label bg-primary'>Auth Section</div>
                        </div>
                        <div className='row m-4'>
                          <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='order_number_map'>
                                {' '}
                                Token Expiration Date
                              </label>
                              <input
                                type='datetime-local'
                                className='form-control form-control-lg'
                                value={temuTokenData?.expire_date ? formatDateString(temuTokenData.expire_date)! : '' }
                                onChange={(ev)=>{
                                  setTemuTokenData((pre)=>{
                                    return {
                                    ...pre,
                                      expire_date: ev.target.value,
                                    }
                                  })
                                }}
                              />
                              
                          </div>

                          <div className='col-12 col-sm-6'>
                            <label className='form-label' htmlFor='order_number_map'>
                              {' '}
                              Auth Token Update <InfoTooltip message="Only update when it's about to expire." />
                            </label>
                            <input
                              type='text'
                              className='form-control form-control-lg'
                              placeholder='Auth Token Update'
                              // value={temuTokenData.token}
                              onChange={(ev)=>{
                                setTemuTokenData((pre)=>{
                                  return {
                                  ...pre,
                                    token: ev.target.value,
                                  }
                                })
                              }}
                            />
                            
                          </div>
                        </div>
                      </div>
                      : null
                    }

                    <div className='mt-5 border shadow rounded'>
                      <div className=' ribbon ribbon-start'>
                        <div className='ribbon-label bg-primary z-0'>Select Product Identifiers</div>
                      </div>
                      <div className='row p-4 gy-4'>
                        {requiresErpIdentifier ? (
                          <>
                            <div className='col-12 col-sm-6'>
                              <label htmlFor='' className='form-label mt-1 required'>
                                Erp Channel Identifier
                              </label>
                              <InfoTooltip
                                message={
                                  'Choose a unique product identifier for your ERP store to link products.'
                                }
                              />
                              <select
                                className='form-select form-select-lg form-select-white'
                                aria-label='Select ERP identifier'
                                name='erp_product_identifier'
                                value={values.erp_product_identifier || ''}
                                onChange={handleChange}
                              >
                                <option value=''>Select Unique identifier</option>
                                {erpOptionsToRender.map((option) => {
                                  const optionValue = getIdentifierValue(option)
                                  if (!optionValue) {
                                    return null
                                  }
                                  return (
                                    <option key={optionValue} value={optionValue}>
                                      {getIdentifierLabel(option)}
                                    </option>
                                  )
                                })}
                              </select>
                            </div>
                            <div className='col-12 col-sm-6 '>
                              <label htmlFor='' className='form-label mt-1 required'>
                                {BaseNames.SECONDARY_Name} Store
                              </label>
                              <InfoTooltip
                                message={
                                  `Choose a unique product identifier for your ${BaseNames.SECONDARY_Name} store to link products.`
                                }
                              />
                              <select
                                className='form-select form-select-lg form-select-white'
                                aria-label='Select secondary identifier'
                                name='secondary_product_identifier'
                                value={values.secondary_product_identifier}
                                onChange={handleChange}
                              >
                                <option value=''>Select Unique identifier</option>
                                {secondaryOptionsToRender.map((option) => {
                                  const optionValue = getIdentifierValue(option)
                                  if (!optionValue) {
                                    return null
                                  }
                                  return (
                                    <option key={optionValue} value={optionValue}>
                                      {getIdentifierLabel(option)}
                                    </option>
                                  )
                                })}
                              </select>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className='col-12 col-sm-6'>
                              <label htmlFor='' className='form-label mt-1 required'>
                                {BaseNames.PRIMARY_Name} Platform
                              </label>
                              <InfoTooltip
                                message={
                                  `Choose a unique product identifier for your ${BaseNames.PRIMARY_Name} to link products.`
                                }
                              />
                              <select
                                className='form-select form-select-lg form-select-white'
                                aria-label='Select example'
                                name='main_product_identifier'
                                value={values.main_product_identifier}
                                onChange={handleChange}
                              >
                                <option value=''>Select Unique identifier</option>
                                {primaryOptionsToRender.map((option) => {
                                  const optionValue = getIdentifierValue(option)
                                  if (!optionValue) {
                                    return null
                                  }
                                  return (
                                    <option key={optionValue} value={optionValue}>
                                      {getIdentifierLabel(option)}
                                    </option>
                                  )
                                })}
                              </select>
                            </div>
                            <div className='col-12 col-sm-6 '>
                              <label htmlFor='' className='form-label mt-1 required'>
                                {BaseNames.SECONDARY_Name} Platform
                              </label>
                              <InfoTooltip
                                message={
                                  `Choose a unique product identifier for your ${BaseNames.SECONDARY_Name} store to link products.`
                                }
                              />
                              <select
                                className='form-select form-select-lg form-select-white'
                                aria-label='Select secondary identifier'
                                name='secondary_product_identifier'
                                value={values.secondary_product_identifier}
                                onChange={handleChange}
                              >
                                <option value=''>Select Unique identifier</option>
                                {secondaryOptionsToRender.map((option) => {
                                  const optionValue = getIdentifierValue(option)
                                  if (!optionValue) {
                                    return null
                                  }
                                  return (
                                    <option key={optionValue} value={optionValue}>
                                      {getIdentifierLabel(option)}
                                    </option>
                                  )
                                })}
                              </select>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className='mt-5 border shadow rounded'>
                      <div className=' ribbon ribbon-start'>
                        <div className='ribbon-label bg-primary z-0'>Order</div>
                      </div>
                      <div className='row p-4 mt-4'>
                        <div className='col-12 col-sm-6'>
                          <div className='form-check form-switch form-check-solid d-flex ps-0 align-items-center '>
                            <label
                              className='form-label  me-10 me-sm-0 fs-4 mb-0'
                              htmlFor='isImportOrderToSource'
                            >
                              Order Sync
                            </label>
                            <input
                              className='form-check-input h-30px w-50px ms-5'
                              type='checkbox'
                              name='order_setting.isImportOrderToSource'
                              onChange={handleChange}
                              checked={values.order_setting.isImportOrderToSource}
                              id='isImportOrderToSource'
                            />
                          </div>
                        </div>
                        <div className='separator mt-3'></div>
                      </div>

                      {values.order_setting.isImportOrderToSource && (
                        <>
                          <div className='row p-4'>
                            <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='isNotifyUnlinkedOrders'>
                                Notify on Unlinked Items or any Failed Orders{' '}
                                <InfoTooltip
                                  message={
                                    'Upon sync failure, you will receive an email with error details and order/item information at your registered email address.'
                                  }
                                />
                              </label>
                              <div className='form-check form-switch form-check-solid '>
                                <input
                                  className='form-check-input h-30px w-50px'
                                  type='checkbox'
                                  name='order_setting.isNotifyUnlinkedOrders'
                                  checked={values.order_setting.isNotifyUnlinkedOrders}
                                  onChange={handleChange}
                                  id='isNotifyUnlinkedOrders'
                                />
                              </div>
                            </div>
                            <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='skipUnpaidOrders'>
                                Skip the Sync of Unpaid Orders{' '}
                                <InfoTooltip
                                  message={
                                    'Any unpaid orders will be automatically skipped and not downloaded'
                                  }
                                />
                              </label>
                              <div className='form-check form-switch form-check-solid '>
                                <input
                                  className='form-check-input h-30px w-50px'
                                  type='checkbox'
                                  name='order_setting.isSkipUnpaidOrders'
                                  checked={values.order_setting.isSkipUnpaidOrders}
                                  onChange={handleChange}
                                  id='skipUnpaidOrders'
                                />
                              </div>
                            </div>
                          </div>
                          <div className='row p-4'>
                            <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='order_number_map'>
                                {' '}
                                Customize Order Number
                              </label>
                              <input
                                type='text'
                                className='form-control form-control-lg'
                                placeholder='e.g. PREFIX-[ORDER_NUMBER]-SUFFIX'
                                name='order_setting.order_number_map'
                                value={values.order_setting.order_number_map}
                                onChange={handleChange}
                              />
                              <div className='text-end w-md-100'>
                                <p
                                  className='text-muted text-hover-primary fw-bold mt-1 cursor-pointer'
                                  onClick={() => setIsShortCodeVisible(!isShortCodeVisible)} // Pass input identifier to handleShortCode}
                                >
                                  <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options
                                  here
                                </p>
                                {isShortCodeVisible && (
                                  <div>
                                    {shortCode?.length &&
                                      shortCode.map((ele: string) => (
                                        <Fragment key={ele}>
                                          <OverlayTrigger
                                            placement='bottom'
                                            overlay={renderTooltip(ele)}
                                          >
                                            <CopyToClipboard text={ele}>
                                              <Button
                                                key={ele}
                                                size='sm'
                                                variant={
                                                  copyMarkup && buttonString === ele
                                                    ? 'outline-success'
                                                    : 'outline-primary'
                                                }
                                                className={`px-3 py-2 m-1 border border-1 ${
                                                  copyMarkup && buttonString === ele
                                                    ? 'border-success'
                                                    : 'border-primary'
                                                } rounded text-hover-dark fs-sm-8 inline-block`}
                                                onClick={() => handleCopyMarkup(ele)}
                                              >
                                                {copyMarkup && buttonString === ele ? (
                                                  <span className='fs-sm-8'>Copied !</span>
                                                ) : (
                                                  ele
                                                )}
                                              </Button>
                                            </CopyToClipboard>
                                          </OverlayTrigger>
                                        </Fragment>
                                      ))}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='order_number_map'>
                                {' '}
                                Order Notes Mapping & customization
                              </label>
                              <input
                                type='text'
                                className='form-control form-control-lg'
                                placeholder='e.g. PREFIX-[ORDER_NUMBER]-SUFFIX'
                                name='order_setting.order_note_map'
                                value={values.order_setting.order_note_map}
                                onChange={handleChange}
                              />
                              <div className='text-end w-md-100'>
                                <p
                                  className='text-muted text-hover-primary fw-bold mt-1 cursor-pointer'
                                  onClick={() => setIsNotesShortCodeVisible(!isNotesShortCodeVisible)} // Pass input identifier to handleShortCode}
                                >
                                  <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options
                                  here
                                </p>
                                {isNotesShortCodeVisible && (
                                  <div>
                                    {shortCode?.length &&
                                      shortCode.map((ele: string) => (
                                        <Fragment key={ele}>
                                          <OverlayTrigger
                                            placement='bottom'
                                            overlay={renderTooltip(ele)}
                                          >
                                            <CopyToClipboard text={ele}>
                                              <Button
                                                key={ele}
                                                size='sm'
                                                variant={
                                                  copyMarkup2 && buttonString2 === ele
                                                    ? 'outline-success'
                                                    : 'outline-primary'
                                                }
                                                className={`px-3 py-2 m-1 border border-1 ${
                                                  copyMarkup2 && buttonString2 === ele
                                                    ? 'border-success'
                                                    : 'border-primary'
                                                } rounded text-hover-dark fs-sm-8 inline-block`}
                                                onClick={() => handleCopyMarkup2(ele)}
                                              >
                                                {copyMarkup2 && buttonString2 === ele ? (
                                                  <span className='fs-sm-8'>Copied !</span>
                                                ) : (
                                                  ele
                                                )}
                                              </Button>
                                            </CopyToClipboard>
                                          </OverlayTrigger>
                                        </Fragment>
                                      ))}
                                  </div>
                                )}
                              </div>
                            </div>
                            {mainStoreData?.name === 'SHOPIFY' ? (
                              <div className='col-12 col-sm-6'>
                                <label className='form-label' htmlFor='tags'>
                                  Tags
                                </label>
                                <input
                                  className=' form-control form-control-lg mw-550px'
                                  name='order_setting.tags'
                                  value={values.order_setting.tags}
                                  onChange={(ev) => {
                                    // let updatedTags  = ev.target.value.split(' ').join(',')

                                    // Step 1: Get the input value
                                    let inputValue = ev.target.value

                                    // Step 2: Replace multiple spaces with a single space
                                    // inputValue = inputValue.replace(/\s+/g, ' ');

                                    // Step 3: Replace spaces with commas
                                    inputValue = inputValue.replace(/ /g, ',')

                                    // Step 4: Replace multiple commas with a single comma
                                    inputValue = inputValue.replace(/,+/g, ',')

                                    // Step 5: Remove any leading or trailing commas
                                    // inputValue = inputValue.replace(/^,|,$/g, '');

                                    // Update the tags state with the cleaned value
                                    setFormikState((pre) => {
                                      return {
                                        ...pre,
                                        values: {
                                          ...pre.values,
                                          order_setting: {...values.order_setting, tags: inputValue},
                                        },
                                      }
                                    })
                                  }}
                                  onBlur={() => {
                                    if (values.order_setting.tags.endsWith(',')) {
                                      let updatedTags = values.order_setting.tags.slice(0, -1) // Remove the trailing comma
                                      setFormikState((pre) => {
                                        return {
                                          ...pre,
                                          values: {
                                            ...pre.values,
                                            order_setting: {
                                              ...values.order_setting,
                                              tags: updatedTags,
                                            },
                                          },
                                        }
                                      })
                                    }
                                  }}
                                />
                              </div>
                            ) : null}
                          </div>
                          {/* <div className='row p-4'>
                            <div className='col-12'>
                              <div className='mt-3 border rounded'>
                                <div className=' ribbon ribbon-start'>
                                  <div className='ribbon-label bg-primary z-0'>
                                    Choose a starting point of Order (in UTC)
                                  </div>
                                </div>
                                <div className='row p-4'>
                                  <div className='col-12 col-sm-6 mt-4'>
                                    <label className='form-label required' htmlFor='goLiveDate'>
                                      Date & Time For Sync
                                    </label>
                                      <InfoTooltip
                                        message={
                                          'Please select the starting date for downloading orders.'
                                        }
                                      />
                                    <input
                                      type='datetime-local'
                                      className='form-control  w-100 '
                                      id='goLiveDate'
                                      name='order_setting.sync_start_date'
                                      value={
                                        values.order_setting?.sync_start_date
                                          ? formatDateString(values.order_setting?.sync_start_date!)!
                                          : ''
                                      }
                                      style={{width: '100%'}} // Inline style for full width
                                      onChange={handleChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {[
                            'NOTONTHEHIGHSTREET',
                            'CATCH',
                            'DEBENHAMS',
                            'SUPERPHARM',
                            'BACKMARKET',
                            'BANDQ',
                            'SECRETSALES',
                          ].includes(retrivedPlatformData?.code ?? '') ? (
                            <div className='row p-4'>
                              <div className='col-12'>
                                <div className='mt-5 border rounded'>
                                  <div className=' ribbon ribbon-start'>
                                    <div className='ribbon-label bg-primary z-0'> Accept Order</div>
                                  </div>
                                  <div className='row p-4 mt-4'>
                                    <div className='col-12 col-sm-6'>
                                      <div className='form-check form-switch form-check-solid d-sm-flex ps-0 align-items-center '>
                                        <label
                                          className='form-label fs-4 mb-0'
                                          htmlFor='accept_order'
                                        >
                                          Accept Order in {retrivedPlatformData?.code}
                                        </label>
                                        <input
                                          className='form-check-input h-30px w-50px ms-5'
                                          type='checkbox'
                                          name='order_setting.isAcceptOrder'
                                          checked={values.order_setting.isAcceptOrder}
                                          id='accept_order'
                                          onChange={handleChange}
                                        />
                                      </div>
                                    </div>
                                    {!['CATCH', 'BACKMARKET', 'BANDQ', 'SECRETSALES'].includes(
                                      retrivedPlatformData?.code!
                                    ) && <div className='separator mt-3'></div>}
                                  </div>

                                  {values.order_setting.isAcceptOrder &&
                                    !['CATCH', 'BACKMARKET', 'BANDQ', 'SECRETSALES'].includes(
                                      retrivedPlatformData?.code!
                                    ) && (
                                      <div className='row p-4'>
                                        <div className='col-12 col-sm-6'>
                                          <label
                                            className='form-label'
                                            htmlFor='estimated_dispatch_days'
                                          >
                                            {' '}
                                            Order Dispatch Time (In Days){' '}
                                          </label>
                                          <input
                                            type='text'
                                            id='estimated_dispatch_days'
                                            className='form-control form-control-lg'
                                            placeholder='name@example.com'
                                            name='order_setting.estimated_dispatch_days'
                                            value={values.order_setting.estimated_dispatch_days + ''}
                                            onChange={handleChange}
                                          />
                                        </div>
                                        <div className='col-12 col-sm-6'>
                                          <label
                                            className='form-label'
                                            htmlFor='estimated_delivery_days'
                                          >
                                            {' '}
                                            Order Delivery Time (In Days){' '}
                                          </label>
                                          <input
                                            type='text'
                                            id='estimated_delivery_days'
                                            name='order_setting.estimated_delivery_days'
                                            value={values.order_setting.estimated_delivery_days + ''}
                                            className='form-control form-control-lg'
                                            placeholder='name@example.com'
                                            onChange={handleChange}
                                          />
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {retrivedPlatformData?.platform_info?.name === 'ICONIC' && (
                            <div className='d-inline-flex form-check form-switch form-check-custom form-check-solid me-10 mt-4 mb-4 '>
                              <label
                                htmlFor='syncOrderCancel'
                                className=' form-check-label text-dark h4 ms-0'
                              >
                                Sync cancelled orders
                              </label>
                              <input
                                type='checkbox'
                                name='order_setting.isImportCanceledOrder'
                                className='ms-8 form-check-input h-20px w-40px'
                                id='order_setting.syncOrderCancel'
                                checked={values.order_setting.isImportCanceledOrder}
                                onChange={handleChange}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <div className='mt-5 border shadow rounded'>
                      <div className=' ribbon ribbon-start'>
                        <div className='ribbon-label bg-primary z-0'>Shipment</div>
                      </div>
                      <div className='row p-4 mt-4'>
                        <div className='col-12 col-sm-6'>
                          <div className='form-check form-switch form-check-solid d-flex ps-0 align-items-center '>
                            <label
                              className='form-label  me-10 me-sm-0  fs-4 mb-0'
                              htmlFor='shipmentSync'
                            >
                              Shipment Sync
                            </label>
                            <input
                              className='form-check-input h-30px w-50px ms-5'
                              type='checkbox'
                              name='shipment_setting.isImportShipmentFromMain'
                              checked={values.shipment_setting.isImportShipmentFromMain}
                              id='shipmentSync'
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className='separator mt-3'></div>
                      </div>

                      {values.shipment_setting.isImportShipmentFromMain && (
                        <div className='row p-4'>
                          {fieldValuesLoader ? (
                            <div className='d-flex align-items-center justify-content-center'>
                              <Loader variant="section" />
                            </div>
                          ) : platformFields.mainStorePlatformField &&
                            platformFields.selectedPlatformOfPlatformField ? (
                            <div className='col-12 col-sm-12'>
                              <ShipmentSyncValues
                                shippingMethodMappings={shippingMethodMappings}
                                mainStoreShipmentData={
                                  shipmentMappingFieldData.shipmentMappingFieldDataForMainStore
                                }
                                selectedStoreShipmentData={
                                  shipmentMappingFieldData.shipmentMappingFieldDataForSelectedStore
                                }
                                addNewItem={() => {
                                  let newItem: ShippingMethodMapping = {id: null}
                                  if (
                                    platformFields.mainStorePlatformField?.input_type === 'SELECT'
                                  ) {
                                    newItem.source_platform_data_id = ''
                                  } else {
                                    newItem.source_platform_data_str = ''
                                  }

                                  if (
                                    platformFields.selectedPlatformOfPlatformField?.input_type ===
                                    'SELECT'
                                  ) {
                                    newItem.destination_platform_data_id = ''
                                  } else {
                                    newItem.destination_platform_data_str = ''
                                  }

                                  setShippingMethodMappings((pre) => {
                                    return [...pre, {...newItem}]
                                  })
                                }}
                                setShipment={(item, itemIndex) => {
                                  let mappings = [...shippingMethodMappings]
                                  if (mappings.length) {
                                    let cure = mappings.find((it, inn) => {
                                      if (inn == itemIndex) {
                                        return it
                                      }
                                    })
                                    if (cure) {
                                      cure = item
                                    }

                                    mappings[itemIndex] = cure!
                                    setShippingMethodMappings(mappings)
                                  }
                                }}
                                deleteMappingItem={(id, index) => {
                                  let copyMppings = [...shippingMethodMappings]
                                  if (id) {
                                    setFieldValuesLoader(true)
                                    dispatch(deleteFieldMappingAsync({mappingDataId: id})).then(
                                      async (response) => {
                                        await dispatch(
                                          getFieldMappingAsync({
                                            destination_platform_id: selectedPlatformId,
                                          })
                                        )
                                        setFieldValuesLoader(false)
                                      }
                                    )
                                  } else {
                                    let filteredMappings = copyMppings.filter((it, ind) => {
                                      if (ind !== index) {
                                        return it
                                      }
                                    })
                                    setShippingMethodMappings(filteredMappings)
                                  }
                                }}
                                mainStorePlatformField={platformFields.mainStorePlatformField}
                                selectedPlatformOfPlatformField={
                                  platformFields.selectedPlatformOfPlatformField
                                }
                              />
                              <div className='d-flex justify-content-end'>
                                <button
                                  type='button'
                                  className='btn btn-success btn-sm mt-2 me-3 align-self-end'
                                  onClick={() => handleSaveShipmentMappings()}
                                >
                                  Save Shipment
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <p>Platform fields not found</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    
                    <div className='mt-5 border   shadow rounded'>
                        <div className=' ribbon ribbon-start'>
                          <div className='ribbon-label bg-primary'>Inventory</div>
                        </div>
                        <div className='row p-4 mt-4'>
                          <div className='col-12 col-sm-6'>
                            <div className='form-check form-switch form-check-solid d-flex ps-0 align-items-center '>
                              <label
                                className='form-label me-10 me-sm-0 fs-4 mb-0'
                                htmlFor='inventorySync'
                              >
                                Inventory Sync
                              </label>
                              <input
                                className='form-check-input h-30px w-50px ms-5'
                                type='checkbox'
                                name='inventory_setting.isInventorySync'
                                checked={values.inventory_setting.isInventorySync}
                                id='inventorySync'
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className='separator mt-3'></div>
                        </div>
                        {values.inventory_setting.isInventorySync && (
                          <div className='row p-4'>
                            <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='buffer'>
                                Set Safety Stock Level
                                <InfoTooltip
                              message={`Safety Stock: Stock displayed on the marketplace UI will be the ${BaseNames.PRIMARY_Name.toLowerCase()} store's stock minus the entered value.`}
                              
                              />
                              </label>
                              <input
                                type='number'
                                name='inventory_setting.buffer'
                                value={values.inventory_setting.buffer}
                                className='form-control form-control-lg w-200px'
                                placeholder=''
                                id='buffer'
                                onChange={handleChange}
                              />
                            </div>
                          { ['BANDCAMP'].includes(retrivedPlatformData?.code!) ?
                            <div className='col-12 col-sm-6'>
                              <label className='form-label' htmlFor='buffer'>
                                Set Default Location <InfoTooltip message='Set default location for inventory' />
                              </label>
                              <select
                                name='inventory_setting.default_location'
                                onChange={handleChange}
                                className='form-select form-select-lg w-sm-75'
                              >
                                <option value="">Select Location</option>
                                { 
                                  mainStoreLocationsFieldData.map((item)=>{
                                    return <option key={item.id} value={item.id}>{item.api_name}</option>
                                  })
                                }
                              </select>
                            </div>
                          : null  }

                          {
                            ['TIKTOK'].includes(retrivedPlatformData?.code!) ? 
                              <div className='row p-4'>
                                {
                                  warehouseMappingLoading ? 
                                  <div className='d-flex align-items-center justify-content-center' >
                                    <Loader variant="section" /> 
                                  </div> :
                                  warehousePlatformFields.mainStorePlatformField && warehousePlatformFields.selectedPlatformOfPlatformField ?
                                  <div className='col-12 col-sm-12'>
                                    <WarehouseMapping
                                      shippingMethodMappings={warehouseMappings}
                                      mainStoreShipmentData={
                                        warehouseMappingData.shipmentMappingFieldDataForMainStore
                                      }
                                      selectedStoreShipmentData={
                                        warehouseMappingData.shipmentMappingFieldDataForSelectedStore
                                      }
                                      addNewItem={() => {
                                        let newItem : ShippingMethodMapping = { id:null }
                                        if(warehousePlatformFields.mainStorePlatformField?.input_type==='SELECT'){
                                          newItem.source_platform_data_id =''
                                        }else{
                                          newItem.source_platform_data_str = ''
                                        }

                                        if(warehousePlatformFields.selectedPlatformOfPlatformField?.input_type==='SELECT'){
                                          newItem.destination_platform_data_id = ''
                                        }else {
                                          newItem.destination_platform_data_str = ''
                                        }

                                        setWarehouseMappings((pre) => {
                                          return [
                                            ...pre,
                                            {...newItem },
                                          ]
                                        })
                                      }}
                                      setShipment={(item, itemIndex) => {
                                        let mappings = [...warehouseMappings]
                                        if (mappings.length) {
                                          let cure = mappings.find((it, inn) => {
                                            if (inn == itemIndex) {
                                              return it
                                            }
                                          })
                                          if (cure) {
                                            cure = item
                                          }

                                          mappings[itemIndex] = cure!
                                          setWarehouseMappings(mappings)
                                        }
                                      }}
                                      deleteMappingItem={(id, index) => {
                                        let copyMppings = [...warehouseMappings]
                                        if (id) {
                                        setWarehouseMappingLoading(true)
                                          dispatch(deleteFieldMappingAsync({mappingDataId: id})).then(
                                            async (response) => {
                                              await dispatch(
                                                getFieldMappingAsync({
                                                  destination_platform_id: selectedPlatformId,
                                                })
                                              )
                                              setWarehouseMappingLoading(false)

                                            }
                                          )
                                        } else {
                                          let filteredMappings = copyMppings.filter((it, ind) => {
                                            if (ind !== index) {
                                              return it
                                            }
                                          })
                                          setWarehouseMappings(filteredMappings)
                                        }
                                      }}
                                      mainStorePlatformField={platformFields.mainStorePlatformField}
                                      selectedPlatformOfPlatformField={platformFields.selectedPlatformOfPlatformField}
                                    />
                                    <div className='d-flex justify-content-end'>
                                      <button
                                        type='button'
                                        className='btn btn-success btn-sm mt-2 me-3 align-self-end'
                                        onClick={() => handleSaveWarehouseMappings()}
                                      >
                                        Save Warehouse
                                      </button>
                                    </div>
                                  </div> : 
                                  <div>
                                    <p>Platform fields not found</p>
                                  </div>
                                  
                                }
                              </div>
                            : null
                          }

                          </div>
                        )}
                    </div>

                    {fetchedUserAccountData?.isEnableProductModule ? process.env['REACT_APP_ENV'] == 'production' &&  ['KOGAN','BACKMARKET','KOGANNZD','EBAY'].includes(retrivedPlatformData?.code!) ||  process.env['REACT_APP_ENV'] == 'staging'  ? (
                      <div className='mt-5 border shadow rounded'>
                        <div className='ribbon ribbon-start p-2'>
                          <div className='ribbon-label bg-primary z-0'>Pricing <sup><span className='badge badge-danger ms-1' style={{fontSize:'8px'}} >Beta</span></sup></div>
                        </div>
                        <div className='row p-4 mt-4'>
                          <div className='col-12 col-sm-6'>
                            {/* <span className='badge badge-danger fs-9'>Beta</span> */}
                            <div className='form-check form-switch form-check-solid d-flex ps-0 align-items-center '>
                              <label
                                className='form-label me-10 me-sm-0 fs-4 mb-0'
                                htmlFor='isPriceSync'
                              >
                                Pricing Sync
                              </label>
                              <input
                                className='form-check-input h-30px w-50px ms-5'
                                type='checkbox'
                                name='pricing_setting.isPriceSync'
                                checked={values?.pricing_setting?.isPriceSync}
                                id='isPriceSync'
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          {/* <div className='separator mt-3'></div> */}
                        </div>
                        {/* {values?.pricing_setting?.isPriceSync && (
      <div className='row p-2 me-2 mb-2'>
        <div className='col-sm-3 col-12 align-items-center d-flex justify-content-sm-center'>
          <p className='form-label text-center mb-0'>Price Adjustment</p>
        </div>
        <div className='col-sm-3 col-12 mt-2 mt-sm-0'>
          <select
            className='form-select form-select-lg'
            onChange={(ev) => {
              if (!isNaN(Number(values?.pricing_setting?.repricing?.value))) {
                const adjustment = ev.target.value === 'decrease' ? -1 : 1;
                setFormikState((prev) => ({
                  ...prev,
                  values: {
                    ...prev.values,
                    pricing_setting: {
                      ...prev.values.pricing_setting,
                      repricing: {
                        ...prev.values?.pricing_setting?.repricing,
                        value: adjustment * Math.abs(Number(prev.values?.pricing_setting?.repricing?.value)) + '',
                      },
                    },
                  },
                }));
              }
            }}
            //    onChange={(ev) => {
            //   if (!isNaN(Number(values.pricing_setting?.repricing?.value))) {
            //     if (ev.target.value == 'decrease') {
            //       setFormikState((pre) => {
            //         return {
            //           ...pre,
            //           values: {
            //             ...pre.values,
            //             repricing: {
            //               type: values.pricing_setting.repricing.type,
            //               value: -1 * Number(values.pricing_setting.repricing.value) + '',
            //             },
            //           },
            //         }
            //       })
            //     } else {
            //       if (Number(values.pricing_setting?.repricing?.value) < 0) {
            //         setFormikState((pre) => {
            //           return {
            //             ...pre,
            //             values: {
            //               ...pre.values,
            //               repricing: {
            //                 type: values.pricing_setting.repricing.type,
            //                 value: -1 * Number(values.pricing_setting.repricing.value) + '',
            //               },
            //             },
            //           }
            //         })
            //       } else {
            //         setFormikState((pre) => {
            //           return {
            //             ...pre,
            //             values: {
            //               ...pre.values,
            //               repricing: {
            //                 type: values.pricing_setting.repricing.type,
            //                 value: Number(values.pricing_setting.repricing.value) + '',
            //               },
            //             },
            //           }
            //         })
            //       }
            //     }
            //   }
            // }}
            defaultValue={
              Number(values?.pricing_setting?.repricing?.value) < 0 ? 'decrease' : 'increase'
            }
          >
            <option value={'increase'}>Increase</option>
            <option value={'decrease'}>Decrease</option>
          </select>
        </div>
        <div className='col-sm-3 col-12 mt-2 mt-sm-0'>
          <div className='d-flex align-items-center '>
            <label className='form-label'>by</label>
            <input
              type='number'
              className='ms-2 form-control form-control-lg '
              placeholder={'Enter value'}
              name='pricing_setting.repricing.value'
              value={values?.pricing_setting?.repricing?.value +''}
              onChange={handleChange}
              
            />
          </div>
        </div>
        <div className='col-sm-3 col-12 mt-2 mt-sm-0'>
          <select
            className='form-select form-select-lg'
            defaultValue={'FLAT'}
            name='pricing_setting.repricing.type'
            onChange={handleChange}
            value={values?.pricing_setting?.repricing?.type }
          >
            <option value={'FLAT'}>Flat Amount</option>
            <option value={'PERCENTAGE'}>Percent</option>
          </select>
        </div>
      </div>
    )} */}
                      </div>
                    ) : null : null }

                    {fetchedUserAccountData?.isEnableProductModule ? (process.env['REACT_APP_ENV'] == 'production' &&  ['KOGAN','BACKMARKET','KOGANNZD','EBAY','OnBuy','TEMU','TIKTOK','FRUUGO'].includes(retrivedPlatformData?.code!)) ||  
                      process.env['REACT_APP_ENV'] == 'staging' && !['SHOPIFY'].includes(fetchedUserAccountData?.source!) ? (
                      <div className='mt-5 border shadow rounded'>
                        <div className=' ribbon ribbon-start p-2'>
                          <div className='ribbon-label bg-primary z-0'>Product <sup><span className='badge badge-danger ms-1' style={{fontSize:'8px'}} >Beta</span></sup></div>
                        </div>
                        <div className='row p-4 mt-4'>
                          <div className='col-12 col-sm-6'>
                            {/* <span className='badge badge-danger fs-9'>Beta</span> */}
                            <div className='form-check form-switch form-check-solid d-flex ps-0 align-items-center '>
                              <label
                                className='form-label fs-4  me-13 me-sm-0 mb-0'
                                htmlFor='isImportProductFromSource'
                              >
                                Product Sync
                              </label>
                              <input
                                className='form-check-input h-30px w-50px ms-5'
                                type='checkbox'
                                checked={values.product_setting?.isImportProductFromSource}
                                id='isImportProductFromSource'
                                onChange={handleChange}
                                name='product_setting.isImportProductFromSource'
                              />
                            </div>
                          </div>
                          <div className='separator mt-3'></div>
                        </div>
                        {values.product_setting?.isImportProductFromSource && (
                          <div className='row p-4'>
                            <div className='col-12 col-sm-6'>
                              <label className='form-label'>
                                {' '}
                                Set a Default Stock level for Non-inventory Products{' '}
                                <InfoTooltip
                                  message={`This stock will be displayed on your marketplace UI`}
                                />
                              </label>
                              <input
                                type='number'
                                className='form-control form-control-lg w-200px'
                                name='product_setting.default_quantity'
                                value={values.product_setting.default_quantity + ''}
                                placeholder=''
                                onChange={handleChange}
                                min='0'
                              />
                            </div>
                            {retrivedPlatformData?.code === 'THERANGEPLUS' && (
                              <div className='col-12  col-sm-6 '>
                                <label className='form-label' htmlFor='export_product'>
                                  Export Product
                                </label>
                                <div className='form-check form-switch form-check-solid '>
                                  <input
                                    className='form-check-input h-30px w-50px'
                                    type='checkbox'
                                    name='product_setting.export_product'
                                    checked={values.product_setting.export_product}
                                    id='export_product'
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ) : null: null}
                  </div>
                )}
              </form>
            )
          }}
        </Formik>
      </div>
    </>
  )
}

export default PlatformConfiguration
